'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import Modal from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'
import FileInputV2 from '@/Form/toolkit/FileInputV2'
import Form        from '@/Form/toolkit/Form'

import { handleChange } from '@/Form/Functions/eventsHandling'

import { safeNumeral, isTrue, getShippingMethodLabel } from '@root/utility'

import _ from 'lodash'

const { app, numeral, moment } = window;

numeral.locale('en');
moment.locale('fr');

export default class ShippingModal extends Component
{
	state =
	{
		open: false,
		data: [],
		form_data: { },
		status_messages: { }
	};

	handleChange = handleChange.bind(this);

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__ShippingModal',
			cb: component.open
		});

		component.setState(
		{
			open: false,
			created: undefined,
			error: undefined,
			data: []
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'open__ShippingModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			data: [],
			created: undefined,
			error: undefined,
			form_data: { },
			status_messages: { }
		});
	}

/**
 *	data:
 *	[
 * 		{
 * 			order:       order data
 * 			selection:   selected tickets in the order
 * 		}
 *   ]
 **/
	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		let selected_items = [];

		data.selection.forEach(function (selection)
		{
			const order = selection.order;

			order.products.forEach(function (product)
			{
				let price = numeral(safeNumeral(product.price.price));

				let grouped = true;

				if ([true, 'true'].includes(product.is_individuel))
				{
					grouped = false;
				}

				if ([true, 'true'].includes(product.price.nominative))
				{
					grouped = false;
				}

				let output;

				if (grouped === true)
				{
					let not_selected = Object.keys(product.tickets)
					.find(function (ticket_id)
					{
						return !selection.selected[ticket_id];
					});

					if (typeof not_selected === 'undefined')
					{
						selected_items.push(
						{
							type: 'product',
							data: product,
							order: order
						});
					}
				}
				else
				{
					output = [];

					Object.keys(product.tickets).forEach(function (ticket_id)
					{
						if (selection.selected[ticket_id])
						{
							selected_items.push(
							{
								id: ticket_id,
								type: 'ticket',
								data: product,
								order: order
							});
						}
					});
				}
			});
		});

		component.setState(
		{
			open : true,
			data: selected_items
		});
	}

	handleValidate = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		var form_data = this.state.form_data, status_messages;

		status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		Object.keys(form_data).forEach(function (field, index)
		{
			if (Boolean(form_data[field]) === form_data[field])
			{
				form_data[field] = false;
			}
			else
			{
				form_data[field] = '';
			}
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			info: response.info,
			loading: false,
			form_data: form_data,
			status_messages: status_messages,
			created: response.created
		});

		if (typeof props.onValidate === 'function') props.onValidate(response);

		app.emit('createdShipping',
		{
			shipping: response.created,
			completed_orders: response.completed_orders
		});
	}

	handleSubmit = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});
	}

	handleFailure = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		this.setState(
		{
			error: response.error,
			warning: response.warning,
			status_messages: status_messages,
			loading: false
		});

		if (typeof props.onFailure === 'function') props.onFailure(response);
	}

	handleFileChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		let name = data.name;

	// Upload files
		state.form_data['__attachments'] = (state.form_data['__attachments'] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			state.form_data['__attachments'].push(data.value[0]);
		}

	// Upload infos
		state.form_data['attachments'] = (state.form_data['attachments'] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			let infos = _.cloneDeep(data.value[0]);

			delete infos.file;
			delete infos.pdf;
			delete infos.image;

			state.form_data['attachments'].push(infos);
		}

		component.setState(
		{
			form_data: state.form_data
		});
	}

	render (e)
	{
		const component = this, props = this.props, state = this.state;

		let info, create_btn, loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		if (state.created)
		{
			info =
			(
				<div className="c-message c-message--green">
					<div className="c-form-message__content">
						La commande a bien été traitée.
					</div>
				</div>
			);
		}
		else
		{
			create_btn =
			(
				<button className="c-btn c-dialog__danger u-margin-left-10"
					type="submit">
					Traiter cette commande
				</button>
			);
		}

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

	/**
	 * Map all status from component.state and return information messages accordingly.
	 *
	 * @param    { Object }    status_data    Infos messages to display.
	 * @param    { String }    index          Iteratof.
	 *
	 * @return    [Array]      Renderable React elements.
	 */
		let status = form_status
		.filter(status_data => typeof state[status_data.label] !== 'undefined')
		.map(function (status_data, index)
		{
			var message =
			(
				<div key={ index } className={ 'c-form-message ' +
					'c-form-message' + status_data.suffix }>
					<div className="c-form-message__content">
						{ state[status_data.label] }
					</div>
				</div>
			);

			return message;
		});

		let product_iterator = 0, item_iterator = 0;

		let items = state.data.map(function (item, index)
		{
			let pattern, item_id;

			if (item.type === 'ticket')
			{
				pattern = 'items[' + (++item_iterator) + ']';

				item_id = item.id;
			}
			else
			{
				pattern = 'products[' + (++product_iterator) + ']';

				state.form_data[pattern + '[price_ref]'] = item.data.price.ref;

				item_id = item.data.price.ref;
			}

			state.form_data[pattern + '[id]'] = item.id || item.data.id;

			state.form_data[pattern + '[order_id]'] = item.order.id;

			let names;

			if (item.type === 'ticket' && item.data.tickets[item.id].name)
			{
				let item_data = item.data.tickets[item.id].name;

				names =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						{
							item_data.firstname + ' ' + item_data.firstname + ' (' +
								moment(item_data.date).format('DD-MM-YYYY') + ')'
						}
						&nbsp;&nbsp; |&nbsp;
					</span>
				);
			}

			let date, age, position, ticket_type, validity_start, validity_date;

			if (item.data.price.date)
			{
				date =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						{ moment(item.data.price.date).format('ddd DD MMM YYYY - HH[h]mm') }
					</span>
				);
			}

			if (item.data.price.ticket_type && item.data.price.ticket_type.label)
			{
				ticket_type =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						{ item.data.price.ticket_type.label }
					</span>
				);
			}

			if (item.data.price.position && item.data.price.position.label)
			{
				position =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						{ item.data.price.position.label }
					</span>
				);
			}

			if (item.data.price.age && item.data.price.age.label)
			{
				age =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						{ item.data.price.age.label }
					</span>
				);
			}

			if (item.data.price.validity_start)
			{
				validity_start =
				(
					<span className="u-margin-right-10">
						&nbsp;| &nbsp;&nbsp;
						Validité&nbsp;: { moment(item.data.price.validity_start).format('DD-MM-YYYY') }
					</span>
				);
			}

			if (item.data.price.validity_date)
			{
				if (item.data.price.validity_start)
				{
					validity_date =
					(
						<span>
							&nbsp;au { moment(item.data.price.validity_date)
								.format('DD-MM-YYYY') }
						</span>
					);
				}
				else
				{
					validity_date =
					(
						<span className="u-margin-right-10">
							&nbsp;| &nbsp;&nbsp;
							Fin de validité&nbsp;: { moment(item.data.price.validity_date).format('DD-MM-YYYY') }
						</span>
					);
				}
			}

			const delivery_method = isTrue(item.data.cart_online_ticket)
			? 'Électronique'
			: getShippingMethodLabel(item.order.shipping.method);

			let output =
			(
				<div className="c-order-product c-order-product--modal"
					key={ (item.id || item.data.id) + '' + index }>

					<div className="c-order-product__qty">
						x
						{
							item.type === 'ticket' ? '1' : item.data.cart_qty
						}
					</div>

					<div className="c-order-product__title">
						<span className="u-margin-right-10">
							{ item.data.name }
						</span>
						{ names }
						{ date }
						{ ticket_type }
						{ position }
						{ age }
						{ validity_start }
						{ validity_date }
					</div>

					<div className="c-order-product__PDF">
						<FileInputV2 data={ state.form_data } onChange={ component.handleFileChange }
							status={ component.state.status_messages }
							name={ item.order.id + '--' + item_id }>
						</FileInputV2>
					</div>

					<div className="c-order-product__shipping-method">
						{ delivery_method }
					</div>

					<div className="c-order-product__number">
						<FormElement type="text" name={ pattern + '[number]' }
							data={ state.form_data } onChange={ component.handleChange }
							placeholder="numéro"
						/>
					</div>

				</div>
			);

			return output;
		});

		let items_header =
		(
			<div className="c-order-product c-order-product--header c-order-product--modal">

				<div className="c-order-product__qty">Quantité</div>
				<div className="c-order-product__title">Titre</div>
				<div className="c-order-product__PDF">PDF</div>
				<div className="c-order-product__shipping-method">
					Livraison
				</div>
				<div className="c-order-product__number">Numéro</div>

			</div>
		);

		let tracking =
		(
			<div className="shipping-modal-tracking">

				<div className="o-grid-2 u-content-end">

					<div className="o-grid__item">
						<FormElement type="text" name="shipping-tracking"
							label="Numéro de suivi" data={ state.form_data }
							onChange={ component.handleChange }
							autoComplete="" />
					</div>
				</div>

			</div>
		);

		if (items.length === 0)
		{
			items_header = undefined;
			items        = undefined;
			tracking     = undefined;
			create_btn   = undefined;

			info =
			(
				<div className="c-message c-message--orange">
					<div className="c-message__content">
						Veuillez sélectionner au moins un produit.
					</div>
				</div>
			);
		}

		if (state.created)
		{
			items_header = undefined;
			items        = undefined;
			tracking     = undefined;
			create_btn   = undefined;
		}

		let delivery_notes = component.getDeliveryNotes(state.created);

		let output =
		(
			<Modal className="o-modal o-modal--large" open={ component.state.open }
				hide_close={ true } title="Traitement de commandes"
				onClose={ component.handleClose }>

				<Form className={ 'shipping-modal-form' } action="/shipping/create"
					hide_button={ true } data={ component.state.form_data }
					onValidate={ component.handleValidate }
					onError={ component.handleFailure }
					onSubmit={ component.handleSubmit }>

					{ items_header }

					{ items }

					{ tracking }

					{ info }

					{ delivery_notes }

					{ status }

					<div className="c-dialog__buttons">
						<button type="button" className="c-btn c-dialog__cancel u-margin-right-0"
							onClick={ component.handleClose }>
							Fermer
						</button>

						{ create_btn }
					</div>

				</Form>

				{ loader }

			</Modal>
		);

		return output;
	}

	getDeliveryNotes = (shipping) =>
	{
		const component = this, props = this.props, state = this.state;

		let orders_ids = [];

		if (!shipping) return undefined;

		shipping.products.concat(shipping.items)
		.forEach(function (data)
		{
			if (orders_ids.includes(data.order_id) === false)
			{
				orders_ids.push(data.order_id);
			}
		});

		let delivery_notes =
		(
			<div className="u-full-width u-flex u-flex-column u-items-start">
				{
					orders_ids.map(function (id)
					{
						let order = state.data.find(item => item.order.id === id).order;

						if (!order)
						{
							return null;
						}

						let link =
						(
							<a className="c-btn c-btn--small u-margin-top-10"
								key={ id } target="_blank" type="application/pdf"
								href={ '/bon-de-livraison/' + id + '/' + shipping.id }
								rel="noreferrer">
								Bon de livraison - { order.number }
							</a>
						);

						return link;
					})
				}
			</div>
		);

		return delivery_notes;
	}
}
